export const NAV = {
  brand: 'nav-brand',
  home: 'nav-home',
  match: 'nav-match',
  protocols: 'nav-protocols',
  trials: 'nav-trials',
  pricing: 'nav-pricing',
  dashboard: 'nav-dashboard',
  admin: 'nav-admin',
  login: 'nav-login',
  register: 'nav-register',
  logout: 'nav-logout',
  themeToggle: 'theme-toggle',
  mobileMenu: 'nav-mobile-menu',
};

export const DISCLAIMER = {
  modal: 'first-visit-disclaimer-modal',
  ackCheckbox: 'first-visit-disclaimer-ack-checkbox',
  ackButton: 'first-visit-disclaimer-ack-button',
  viewFullLink: 'first-visit-disclaimer-view-full-link',
  footer: 'global-footer',
  footerText: 'footer-medical-disclaimer',
};

export const AUTH_F = {
  registerForm: 'register-form',
  registerEmail: 'register-email',
  registerPassword: 'register-password',
  registerSubmit: 'register-submit',
  loginForm: 'login-form',
  loginEmail: 'login-email',
  loginPassword: 'login-password',
  loginSubmit: 'login-submit',
  adminSecret: 'register-admin-secret',
};

export const MATCH = {
  form: 'match-form',
  submit: 'match-submit',
  results: 'match-results',
  resultCard: 'match-result-card',
  exportCsv: 'match-export-csv',
  mechanismFilter: 'match-mechanism-filter',
  interventionFilter: 'match-intervention-filter',
  saveProfile: 'match-save-profile',
  evidenceLegendOpen: 'match-evidence-legend',
};

export const PROTO = {
  card: 'protocol-card',
  sourceLink: 'protocol-card-source-link',
  viewButton: 'protocol-card-view-button',
  tierLock: 'protocol-card-tier-lock',
  contraindicationBox: 'contraindication-warning-box',
  evidenceBadge: 'evidence-level-badge',
  citationsPending: 'citations-pending-badge',
};

export const TRIAL = {
  card: 'trial-card',
  link: 'trial-card-link',
  mechanismSelect: 'trial-mechanism-select',
};

export const PRICE = {
  freeCard: 'pricing-free-card',
  researcherCard: 'pricing-researcher-card',
  upgradeButton: 'pricing-upgrade-button',
};

export const ADMIN = {
  newProtocolBtn: 'admin-new-protocol',
  saveProtocolBtn: 'admin-save-protocol',
  weightsForm: 'admin-weights-form',
  feedbackTab: 'admin-feedback-tab',
  protocolsTab: 'admin-protocols-tab',
  weightsTab: 'admin-weights-tab',
};

export const STATE = {
  loading: 'page-loading-state',
  empty: 'page-empty-state',
  error: 'page-error-state',
  retry: 'page-error-retry-button',
  emptyAction: 'empty-state-primary-action',
};
